import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LocalizedSchemaService } from '../../../services/localized-schema.service';

@Component({
  selector: 'app-ki-agenten',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './ki-agenten.component.html',
  styleUrl: './ki-agenten.component.scss'
})
export class KiAgentenComponent implements OnInit, OnDestroy {
  private readonly schemaId = 'ai-service-schema';

  constructor(@Inject(DOCUMENT) private document: Document, private schema: LocalizedSchemaService) { }

  ngOnInit(): void {
    if (this.document.getElementById(this.schemaId)) {
      return;
    }

    const script = this.document.createElement('script');
    script.id = this.schemaId;
    script.type = 'application/ld+json';
    script.text = this.schema.serialize({
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'Service',
          name: $localize`KI-Agenten und KI-Beratung für Unternehmen`,
          serviceType: $localize`KI-Beratung, Entwicklung von KI-Agenten und Integration künstlicher Intelligenz`,
          description: $localize`AlbCode entwickelt individuelle KI-Assistenten und KI-Agenten und berät Unternehmen bei der Einführung praxistauglicher KI-Lösungen.`,
          url: 'https://www.albcode.de/albcode/ki-agenten',
          areaServed: {
            '@type': 'Country',
            name: $localize`Deutschland`
          },
          provider: {
            '@type': 'Organization',
            name: $localize`AlbCode`,
            url: 'https://www.albcode.de/'
          }
        },
        {
          '@type': 'BreadcrumbList',
          itemListElement: [
            {
              '@type': 'ListItem',
              position: 1,
              name: $localize`Startseite`,
              item: 'https://www.albcode.de/'
            },
            {
              '@type': 'ListItem',
              position: 2,
              name: $localize`KI und KI-Agenten`,
              item: 'https://www.albcode.de/albcode/ki-agenten'
            }
          ]
        },
        {
          '@type': 'FAQPage',
          mainEntity: [
            {
              '@type': 'Question',
              name: $localize`Was ist ein KI-Agent?`,
              acceptedAnswer: {
                '@type': 'Answer',
                text: $localize`Ein KI-Agent kombiniert ein Sprachmodell mit Unternehmenswissen, Regeln und angebundenen Werkzeugen. Dadurch kann er Informationen verarbeiten und definierte Arbeitsschritte unterstützen.`
              }
            },
            {
              '@type': 'Question',
              name: $localize`Muss ein KI-Agent vollständig autonom arbeiten?`,
              acceptedAnswer: {
                '@type': 'Answer',
                text: $localize`Nein. Berechtigungen, Grenzen und Freigabeschritte werden passend zum Prozess festgelegt. Kritische Aktionen können immer eine menschliche Bestätigung erfordern.`
              }
            },
            {
              '@type': 'Question',
              name: $localize`Kann ein KI-Agent vorhandene Unternehmensdaten nutzen?`,
              acceptedAnswer: {
                '@type': 'Answer',
                text: $localize`Ja. Je nach Anwendungsfall können freigegebene Dokumente, Datenbanken, Portale oder Schnittstellen unter Berücksichtigung der Zugriffsrechte angebunden werden.`
              }
            }
          ]
        }
      ]
    });

    this.document.head.appendChild(script);
  }

  ngOnDestroy(): void {
    this.document.getElementById(this.schemaId)?.remove();
  }
}
